module.exports = __webpack_public_path__ + "img/antes_despues_286.dcb86160.png";